import React, { useEffect } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect, useDispatch } from 'react-redux';

import {
  catalogBibShape,
  libraryShape,
  listShape,
  userIdentityShape,
  paginationShape
} from '@bibliocommons/bc-prop-types';

import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';
import { getRelationships } from 'app/actions/RelationshipsActions';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import {
  selectCommunityListsForCurrentBib,
  selectCommunityListsPagination
} from 'app/selectors/bibs/DiscoverySelector';
import CommunityLists from './CommunityLists';

export function CommunityListsContainer(props) {
  const { currentUser, lists } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    if (currentUser?.isEmpty() ?? true) {
      return;
    }

    const listOwnerIds = lists?.map(list => list.getIn(['owner', 'id']));

    dispatch(getRelationships({ userId: currentUser.get('id'), userIds: listOwnerIds }));
  }, [currentUser, dispatch, lists]);

  function handleListTitleClick(listId, listTitle) {
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'community-lists-featuring-this-title',
      ui_component_type: 'link-text',
      ui_component_label: listTitle
    };

    dispatch(
      trackContentClick({
        listId,
        ui
      })
    );
  }

  function handleListImageClick(listId) {
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'community-lists-featuring-this-title',
      ui_component_type: 'link-image'
    };
    dispatch(
      trackContentClick({
        listId,
        ui
      })
    );
  }

  return (
    <CommunityLists
      {...props}
      handleListTitleClick={handleListTitleClick}
      handleListImageClick={handleListImageClick}
    />
  );
}

CommunityListsContainer.propTypes = {
  currentUser: userIdentityShape,
  library: libraryShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  pagination: paginationShape.isRequired,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  currentUser: selectCurrentUser(state),
  users: selectUserEntities(state),
  lists: selectCommunityListsForCurrentBib(state),
  pagination: selectCommunityListsPagination(state),
  library: selectCurrentLibrary(state)
});

export default connect(mapStateToProps)(CommunityListsContainer);
